<template>
<div
  class="text-element"
  :style="elementStyle"
  :class="{ 'text-element--selected': selected }"
  @pointerdown.stop="onPointerDown"
  @click.stop="$emit('select', element)"
>
    <!-- Texto o input de edición -->
    <div
    v-if="!isEditing"
    class="text-element__content"
    :style="contentStyle"
    @dblclick.stop="startEdit"
    >
    {{ localText || 'Texto...' }}
    </div>

    <textarea
    v-else
    ref="textarea"
    v-model="localText"
    class="text-element__textarea"
    :style="contentStyle"
    @blur="stopEdit"
    @keydown.esc="stopEdit"
    @pointerdown.stop
    />

    <!-- Botón eliminar -->
    <button
    v-if="!readonly"
    class="text-element__remove"
    @pointerdown.stop
    @click.stop="$emit('remove', element)"
    >
    X
    </button>

    <!-- Handle resize -->
    <div
    v-if="!readonly"
    class="text-element__resize"
    @pointerdown.stop="onResizeDown"
    />
</div>
</template>

<script>
const DEFAULT_WIDTH  = 120
const DEFAULT_HEIGHT = 40

export default {
name: 'TextElement',

props: {
    element:  { type: Object, required: true },
    position: { type: Object, required: true },
    scale:    { type: Number, default: 1     },
    readonly: { type: Boolean, default: false },
    selected: { type: Boolean, default: false },
},

data() {
    return {
    isEditing: false,
    localText: this.element.text || '',
    }
},

computed: {
    elementStyle() {
    return {
        left:   `${this.position.x}px`,
        top:    `${this.position.y}px`,
        width:  `${this.position.width  || DEFAULT_WIDTH}px`,
        height: `${this.position.height || DEFAULT_HEIGHT}px`,
    }
    },
    contentStyle() {
    return {
        fontSize:   `${this.element.fontSize  || 14}px`,
        color:      this.element.color        || '#000000',
        background: this.element.background   || 'rgba(255,255,255,0.85)',
        fontWeight: this.element.bold ? '700' : '400',
    }
    },
},

methods: {
    startEdit() {
    if (this.readonly) return
    this.isEditing = true
    this.$nextTick(() => this.$refs.textarea?.focus())
    },

    stopEdit() {
    this.isEditing = false
    this.$emit('update-text', { element: this.element, text: this.localText })
    },

    onPointerDown(e) {
    if (this.readonly) return
    if (e.target.closest('button') || e.target.closest('textarea')) return
    this.$emit('select', this.element)
    e.preventDefault()

    const startMouseX = e.clientX
    const startMouseY = e.clientY
    const startPosX   = this.position.x
    const startPosY   = this.position.y

    const onMove = (ev) => {
        const dx = (ev.clientX - startMouseX) / this.scale
        const dy = (ev.clientY - startMouseY) / this.scale
        this.$emit('update-position', {
        element:  this.element,
        position: {
            ...this.position,
            x: startPosX + dx,
            y: startPosY + dy,
        }
        })
    }
    const onUp = () => {
        window.removeEventListener('pointermove', onMove)
        window.removeEventListener('pointerup', onUp)
    }
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    },

    onResizeDown(e) {
    e.preventDefault()
    const startMouseX = e.clientX
    const startMouseY = e.clientY
    const startW = this.position.width  || DEFAULT_WIDTH
    const startH = this.position.height || DEFAULT_HEIGHT

    const onMove = (ev) => {
        const dx = (ev.clientX - startMouseX) / this.scale
        const dy = (ev.clientY - startMouseY) / this.scale
        this.$emit('update-position', {
        element:  this.element,
        position: {
            ...this.position,
            width:  Math.max(60,  startW + dx),
            height: Math.max(24,  startH + dy),
        }
        })
    }
    const onUp = () => {
        window.removeEventListener('pointermove', onMove)
        window.removeEventListener('pointerup', onUp)
    }
    window.addEventListener('pointermove', onMove)
    window.addEventListener('pointerup', onUp)
    },
}
}
</script>

<style lang="scss" scoped>
.text-element {
position: absolute;
z-index: 10;
cursor: grab;
user-select: none;

&:active { cursor: grabbing; }

&__content {
    width: 100%;
    height: 100%;
    padding: 4px 6px;
    border-radius: 4px;
    border: 1px dashed #aaa;
    font-size: 14px;
    line-height: 1.4;
    word-break: break-word;
    overflow: hidden;
    box-sizing: border-box;
    cursor: grab;
}

&__textarea {
    width: 100%;
    height: 100%;
    padding: 4px 6px;
    border-radius: 4px;
    border: 1px solid #007bff;
    font-size: 14px;
    line-height: 1.4;
    resize: none;
    box-sizing: border-box;
    outline: none;
    cursor: text;
}

&__remove {
    position: absolute;
    top: -8px;
    right: -8px;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: none;
    background: red;
    color: white;
    font-size: 10px;
    cursor: pointer;
    z-index: 20;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover { background: #c00000; }
}

&__resize {
    position: absolute;
    bottom: -5px;
    right: -5px;
    width: 12px;
    height: 12px;
    background: #007bff;
    border-radius: 50%;
    cursor: nwse-resize;
    z-index: 11;

    &:hover {
    background: #0056b3;
    transform: scale(1.2);
    }
}
}

.text-element--selected {
  .text-element__content {
    border-color: #007bff;
    border-style: solid;
  }
}
</style>